import React, { useState, useEffect, useContext } from "react";
import AddButton from "../../../_default/AddButton";
import DropDown from "../../../_default/DropDown";
import UserContext from "../../../../services/context/userContext";
import Input from "../../../_default/Input";
import Button from "../../../_default/Button";
import Icon from "../../../_default/Icon";
import Popup from "../../../_default/Popup";
import { getClients, getCLientByName, getCalendarCoach } from "../../../../services/firebase/firestore/getData";
import { addTodoClient, addTodoTask } from "../../../../services/firebase/firestore/saveData";
import { deleteAppointment } from "../../../../services/firebase/firestore/deleteData";
import "./TodoList.scss";

export default function TodoList({ style,setItemAdded,setItemDeleted, Time, fulltime, shortFulltime }) {
  const [showPopup, setShowPopup] = useState(false);
  const [filterType, setFilterType] = useState('Client');
  const filtersType = ["Client", "Item"];
  const [filter, setFilter] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const [client_name, setCLientName] = useState(false);
  const [filterIcon, setFilterIcon] = useState('Urgent');
  // const filtersIcon = ["red-flag", "green-flag", "blue-flag", "heart", "dollar", "food", "smiley", "mail", "phone", "items"]
  const filtersIcon = ["Urgent", "Reminder", "To-do",  "Finances", "Meal",  "Emails", "Call", "Programs"]
  const [error, setError] = useState(false);
  const user = useContext(UserContext);
  const [calendarItems, setCalendarItems] = useState(false);

  const handelDeleteItem=(item)=>{
    setItemDeleted(true)
    setShowPopup(item)
  }

  useEffect(() => {
    getClients(user.id, (result) => {
      let clientNames = [];
      result && result.forEach(element => {
        clientNames.push(element.first_name + " " + element.last_name);
      });
      setFilterName(clientNames);
      if (result.length > 0) {
        setCLientName(result[0].first_name + " " + result[0].last_name);
      }

    });
  }, [user.id]);

  useEffect(() => {
    if (Time) {
      getCalendarItems();
    }
  }, [Time])

  function onAddItem() {
    document.querySelector('.c-todolist').classList.add('hidden');
    document.querySelector('.c-todolist-add-item').classList.remove('hidden');
  }

  function getCalendarItems() {
    getCalendarCoach(user.id, Time, (result) => {
      setCalendarItems(result);
    });
  }

  function compare(a, b) {
    if (a.time < b.time) return -1;
    if (a.time > b.time) return 1;
    return 0;
  }

  const iconData = {
    "red-flag": require('./images/red-flag.png').default,
    "green-flag": require('./images/green-flag.png').default,
    "blue-flag": require('./images/blue-flag.png').default,
    "heart": require('./images/heart.png').default,
    "dollar": require('./images/dollar.png').default,
    "food": require('./images/food.png').default,
    "smiley": require('./images/smiley.png').default,
    "mail": require('./images/mail.png').default,
    "phone": require('./images/phone.png').default,
    "items": require('./images/items.png').default
  };


  calendarItems && calendarItems.sort(compare);

  function onSubmitClient() {
    if (!document.querySelector('.c-input-client-location input').value) {
      setError({ type: "location", message: "Please enter the location" })
    } else if (!document.querySelector('.c-input-client-hour').value || !document.querySelector('.c-input-client-minute').value) {
      setError({ type: "time", message: "Please enter the time" })
    } else if (document.querySelector('.c-input-client-hour').value > 24 || document.querySelector('.c-input-client-hour').value < 0 || document.querySelector('.c-input-client-minute').value > 60 || document.querySelector('.c-input-client-minute').value < 0) {
      setError({ type: "time", message: "Please enter an existing time" })
    } else if (document.querySelector('.c-input-client-hour').value === 24 && document.querySelector('.c-input-client-minute').value !== 0) {
      setError({ type: "time", message: "Please enter an existing time 2" })
    } else {
      setError(false)
      let index = client_name.indexOf(" ");  // Gets the first index where a space occours
      let first_name = client_name.substr(0, index); // Gets the first name part
      let last_name = client_name.substr(index + 1);  // Gets the last name part
      let location = document.querySelector('.c-input-client-location input').value;
      let hour = document.querySelector('.c-input-client-hour').value;
      let minute = document.querySelector('.c-input-client-minute').value;
      if (hour.length < 2) {
        hour = "0" + hour;
      }
      if (minute.length < 2) {
        minute = "0" + minute;
      }
      let time = hour + ":" + minute;
      let timestamp = new Date();
      getCLientByName(first_name, last_name, (result) => {
        let clientData = result;
        let client = {
          "first_name": first_name,
          "last_name": last_name,
          "image": clientData[0].image ? clientData[0].image : "",
          "location": {
            "name": location
          },
          "type": "clients",
          "time": time,
          "timestamp": timestamp
        }
        addTodoClient(client, user.id, Time, (result) => {
          setItemAdded(true)
          getCalendarItems();
          document.querySelector('.c-todolist-add-item').classList.add('hidden');
          document.querySelector('.c-todolist').classList.remove('hidden');
        })
      })
    }
  }

  function onSubmitItem() {
    if (!document.querySelector('.c-input-item-task input').value) {
      setError({ type: "task", message: "Please enter the task" })
    } else if (!document.querySelector('.c-input-item-location input').value) {
      setError({ type: "location", message: "Please enter the location" })
    } else if (!document.querySelector('.c-input-item-hour').value || !document.querySelector('.c-input-item-hour').value) {
      setError({ type: "time", message: "Please enter the time" })
    } else if (document.querySelector('.c-input-item-hour').value > 24 || document.querySelector('.c-input-item-hour').value < 0 || document.querySelector('.c-input-item-minute').value > 60 || document.querySelector('.c-input-item-minute').value < 0) {
      setError({ type: "time", message: "Please enter an existing time" })
    } else if (document.querySelector('.c-input-item-hour').value === 24 && document.querySelector('.c-input-item-minute').value !== 0) {
      setError({ type: "time", message: "Please enter an existing time 2" })
    } else {
      setError(false);
      let icon = filterIcon;
      let location = document.querySelector('.c-input-item-location input').value;
      let taskItem = document.querySelector('.c-input-item-task input').value;
      let hour = document.querySelector('.c-input-item-hour').value;
      let minute = document.querySelector('.c-input-item-minute').value;
      if (hour.length < 2) {
        hour = "0" + hour;
      }
      if (minute.length < 2) {
        minute = "0" + minute;
      }
      let time = hour + ":" + minute;
      let timestamp = new Date();
      let task = {
        "icon": icon,
        "location": {
          "name": location
        },
        "task": taskItem,
        "time": time,
        "timestamp": timestamp,
        "type": "tasks"
      }
      addTodoTask(task, user.id, Time, (result) => {
        getCalendarItems();
        setItemAdded(true)
        document.querySelector('.c-todolist-add-item').classList.add('hidden');
        document.querySelector('.c-todolist').classList.remove('hidden');
      })
    }
  }

  function onCancel() {
    document.querySelector('.c-todolist-add-item').classList.add('hidden');
    document.querySelector('.c-todolist').classList.remove('hidden');
  }

  function removeAppointment(item) {
    deleteAppointment(user.id, item.id, item.type, Time, (result) => {
      getCalendarItems();
      setShowPopup(false);
      window.location.reload()
    })
  }

  return (
    <>
      <div className="c-todolist" style={{ overflowY: "scroll", height: "400px", marginTop: "12px", marginBottom: "12px", borderRadius: "3px", }}>
        {fulltime ? <p className="c-calendar-items-time" >{fulltime}</p> : ""}
        <div className="c-calendar-appointments">
          {calendarItems && calendarItems.map((item) => {
            // console.log("item icon", item)
            let time = item.time;
            var index = time.indexOf(":");  // Gets the first index where a space occours
            var hour = time.substr(0, index); // Gets the first name part
            var minutes = time.substr(index + 1);  // Gets the last name part

            return <div key={item.id} className="c-appointment" style={{ justifyContent:"space-between" }}>
              <div style={{ display: "flex" }}>
                {item.icon ? <img className="list-icons" src={require(`./images/${(item.icon=="1"||item.icon=="red-flag"||item.icon=="Urgent")?"red-flag":(item.icon=="2"||item.icon=="green-flag")?"green-flag":(item.icon=="3"||item.icon=="blue-flag")?"blue-flag":(item.icon=="4"||item.icon=="heart")?"heart":(item.icon=="5"||item.icon=="dollar")?"dollar":(item.icon=="6"||item.icon=="food")?"food":(item.icon=="7"||item.icon=="smiley")?"smiley":(item.icon=="8"||item.icon=="mail")?"mail":(item.icon=="9"||item.icon=="phone")?"phone":item.icon=="10"?"items":item.icon}.png`)} /> : DisplayImage(item.image)}
                {/* <img className="list-icons" src={require("./images/blue-flag.png")}/> */}
                {/* {item.icon ? <img className="list-icons" src={require(`./images/${typeof(item.icon==Number?item.icon:"dollar")}.png`).default} /> : DisplayImage(item.image)} */}
                <div className="c-clients-profile-text">
                  <p>{item.type === "clients" ? item.first_name + " " + item.last_name : item.task}</p>
                  <span>@{item?.location?.name ? item.location.name : "??"}</span>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="c-time">
                  <div className="c-timestamp c-timestamp-hour">{hour}</div>
                  <h2 className="c-timestamp-colon">:</h2>
                  <div className="c-timestamp c-timestamp-hour">{minutes}</div>
                </div>
                {/* <div className="c-set-trash-icon" onClick={() => setShowPopup(item)}> */}
                <div className="c-set-trash-icon" onClick={()=>handelDeleteItem(item)}>
                  <Icon icon="trash" size={16} />
                </div>
              </div>
            </div>
          })}

        </div>

        <AddButton text="Add Item" color="#000" backgroundColor="#FFC415" style={style} onClick={() => onAddItem()} />
      </div>
      <div className="c-todolist-add-item hidden">
        {shortFulltime ? <p className="c-calendar-items-time" >Add item on {shortFulltime}</p> : ""}
        <div className="c-todo-list-add-container">
          <DropDown zindex={9999} options={filtersType} value={filterType} onChange={(e) => setFilterType(e)} />
          {filterType && filterType === "Client" ?
            <div className="c-todolist-add-client">
              <DropDown options={filterName ? filterName : []} value={filter} onChange={(e) => { setFilter(e); setCLientName(e); }} />
              <div className="c-input-client-location">
                <Input type="text" placeholder="Location" label="Location" error={error && error.type === "location" ? error.message : false} errorStyles={{ width: "150px" }} />
              </div>
              <div className="c-input-time-container">
                <Input className="c-input-client-hour" type="number" placeholder="00" label="Time" min={0} max={24} />
                {/* <input  type="number" min={0} max={4} /> */}

                <h1>:</h1>
                <Input className="c-input-client-minute" type="number" placeholder="00" label=" " min={0} max={60} />
              </div>
              <div className="c-input-wrapper">
                <p className="c-default-error-message">{error && error.type === "time" ? error.message : false}</p>
              </div>
              <div className="c-button-collection c-button-collection-todo">
                <Button text="Save" color="#fff" backgroundColor="#00BDA5" className="c-close-btn--save" onSubmit={() => onSubmitClient(false)} />
                <button className="c-cancel-btn" onClick={() => onCancel()}>
                  Cancel
                </button>
              </div>
            </div>
            :
            <div className="c-todolistxx-add-item">
              <div className="c-input-item-task">
                <Input type="text" placeholder="Description" label="Item description" error={error && error.type === "task" ? error.message : false} errorStyles={{ width: "150px" }} />
              </div>
              <div style={{ display: 'flex' }}>
                {/* <div style={{ flexSchrink: 1, display: 'flex', alignItems: 'center', backgroundColor: '#000', padding: '5px 15px', marginLeft: 10, borderRadius: 12 }}>{filterIcon && <img src={iconData[filterIcon]} alt="Logo" />}</div> */}
                <div style={{ flexSchrink: 1, display: 'flex', alignItems: 'center', backgroundColor: '#000', padding: '5px 15px', marginLeft: 10, borderRadius: 12 }}>{filterIcon && <img src={require("./images/"+filterIcon+".png")} alt="Logo" />}</div>
                <DropDown options={filtersIcon} value={filterIcon} onChange={(e) => { setFilterIcon(e) }} />
              </div>
              <div className="c-input-item-location">
                <Input type="text" placeholder="Location" label="Location" error={error && error.type === "location" ? error.message : false} errorStyles={{ width: "150px" }} />
              </div>
              <div className="c-input-time-container">
                <Input className="c-input-item-hour" type="number" placeholder="00" label="Time" />
                <h1>:</h1>
                <Input className="c-input-item-minute" type="number" placeholder="00" label=" " />
              </div>
              <div className="c-input-wrapper">
                <p className="c-default-error-message">{error && error.type === "time" ? error.message : false}</p>
              </div>
              <div className="c-button-collection c-button-collection-todo">
                <Button text="Save" color="#000" backgroundColor="#FFC415" className="c-close-btn--save" onSubmit={() => onSubmitItem(false)} />
                <button className="c-cancel-btn" onClick={() => onCancel()}>
                  Cancel
                </button>
              </div>
            </div>
          }

        </div>
      </div>
      {showPopup && <Popup title={"Remove item"} button="Remove" deletePopup={true} description={"Are you sure you want to remove this item? This can not be undone."} onCancel={() => setShowPopup(false)} onAction={() => removeAppointment(showPopup)} />}
    </>
  );
}

function DisplayIcon(icon) {
  debugger
  return <div className="c-clients-list-image c-clients-list-icon"><Icon icon={icon} size="35px" /> </div>
}

function DisplayImage(image) {
  return <div className="c-clients-list-image" style={{ backgroundImage: `url('${image}')` }}>
    <div className="c-active"></div>
  </div>
}